<template :pageData="pageData">
	<div class="page-wrapper">
		<div class="header">
			<div class="title">Clover Themes</div>
			<a href="https://github.com/xzhih/hackintosh-list" class="submit">Submit</a>
		</div>
		<div class="wrapper t-center">
			<template v-for="(theme, index) in pageData.Theme">
				<a class="theme-card shadow" :key="index" target="_blank" :title="theme.Name" :href="theme.Link">
					<img v-lazy="theme.Screenshot" :alt="theme.Name">
					<span>{{ theme.Name }}</span>
				</a>
			</template>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Themes',
		props: ['pageData']
	}
</script>

<style src="../assets/style.css"></style>
